import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {
    SUMMARY_ALL,
    SUMMARy_ALL,
    SUMMARY_OTHERS,
    SUMMARY_PROJECTS,
    SUMMARY_SELF_INTRODUCTION
} from "../../actions/path";

const Summary = () => {

    // 페이지 이동하려면 사용해야 되는
    const currentPathSelector = useSelector(state => state.pathReducers.currentPath);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        navigate(currentPathSelector);
    }, [currentPathSelector]);
    // ---------------------------------

    const summaryHeaderTitle = 'About me';
    const commonMoveText = '자세히 보기';
    const summaryList = [
        {
            title: '소개',
            content: '<p>가장 자신있는 키워드 3가지</p><p><b>#성실함 #책임감 #열정</b></p>',
            icon: '📢',
            detailPath: SUMMARY_SELF_INTRODUCTION,
        },
        {
            title: '프로젝트',
            content: '<p>나의 커리어 항해일지</p><p>현재도 순항 중</p>',
            icon: '⛵',
            detailPath: SUMMARY_PROJECTS,
        },
        {
            title: 'Others',
            content: '<p>나를 어필할 수 있는</p><p>그 외 것들 (교육, 자격증, 기술)</p>',
            icon: 'ℹ️',
            detailPath: SUMMARY_OTHERS,
        },
        {
            title: 'All',
            content: '<p>개발자 이준복의</p><p>모든 것을 한 번에 보기</p>',
            icon: '🔎',
            detailPath: SUMMARY_ALL,
        }
    ]

    return (
        <div className='container px-4 py-5'>
            <h2 className='about-me pb-2 border-bottom'>{summaryHeaderTitle}</h2>
            <div className="row g-4 py-5 row-cols-1 row-cols-lg-4">
                {summaryList?.map((summary,index) =>
                    <div className="feature col"
                         key={`summary-${index+1}`}
                         id={`choice-summary-${index+1}`}>
                        <div
                        className="feature-icon d-inline-flex align-items-center justify-content-center bg-gradient fs-2 mb-3">
                        {/*<svg className="bi" width="1em" height="1em" aria-hidden="true">*/}
                        {/*<use href="#collection"></use>*/}
                        {/*</svg>*/}
                            {summary.icon}
                        </div>
                        <h3 className="fs-2 text-body-emphasis">{summary?.title}</h3>
                        <div dangerouslySetInnerHTML={{__html: summary?.content}}/>
                        <div className='right-align'>
                            <a href="#" className="font-highlight
                            no-line-href icon-link"
                               onClick={(e) => {
                                    e.preventDefault();
                                    dispatch({type: summary?.detailPath,});
                            }}>
                            {commonMoveText}
                                🔻
                                {/*<svg className="bi" aria-hidden="true">*/}
                                {/*    <use href="#chevron-right">*/}
                                {/*    </use>*/}
                                {/*</svg>*/}
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Summary;